import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { AlertTriangle, CreditCard, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function AddonPaymentAlert() {
  const { t } = useTranslation();
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/shop/addon").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s?.payment_failed) return null;
  const update = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/shop/addon/update-card");
      window.location.href = data.url;
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || e.message);
      setBusy(false);
    }
  };
  return (
    <div data-testid="addon-payment-failed" className="rounded-2xl border border-red-200 bg-red-50 p-6 flex flex-col sm:flex-row sm:items-center gap-4">
      <div className="w-10 h-10 rounded-xl bg-red-100 text-red-700 flex items-center justify-center shrink-0"><AlertTriangle size={18} /></div>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-red-900">{t("shopAddon.paymentFailedTitle")}</div>
        <p className="text-sm text-red-800 mt-0.5">{t("shopAddon.paymentFailedBody")}</p>
      </div>
      <Button onClick={update} disabled={busy} data-testid="addon-update-card-btn" className="bg-red-600 hover:bg-red-500 text-white h-10 shrink-0">
        {busy ? <Loader2 size={14} className="mr-2 animate-spin" /> : <CreditCard size={14} className="mr-2" />}{t("shopAddon.updateCard")}
      </Button>
    </div>
  );
}
